import React from 'react';
import { AddCaseAssessments } from 'pages/components';

const ContactNewAddCaseAssessments = (props) => (
  <AddCaseAssessments {...props} />
);

export default ContactNewAddCaseAssessments;
